import { render } from "./StringSwitcher.vue?vue&type=template&id=062842e4&scoped=true&ts=true"
import script from "./StringSwitcher.vue?vue&type=script&lang=ts"
export * from "./StringSwitcher.vue?vue&type=script&lang=ts"

import "./StringSwitcher.vue?vue&type=style&index=0&id=062842e4&lang=scss&scoped=true"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-062842e4"]])

export default __exports__